import { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { useComponentConfig } from '@namespace/cms';
import { USER_ROLES, UserContext } from '@namespace/user';
import { IS_USE_PLEX_API } from '../../constants';
import { gamesStoreActions, useGamesStore } from '../../store';
import { useCasinoSettings } from '../useCasinoSettings';
import { useGetLoadFeedGamesCallback } from '../useGetLoadFeedGamesCallback';

const { GET_RECENTLY_PLAYED_LIST, RESET_RECENTLY_PLAYED_LIST } =
  gamesStoreActions;

export const useLoadRecentlyPlayed = (
  casinoType,
  {
    feedName,
    limit,
    isRecentDataRequired = true,
    isShowRecentlyPlayedCategoryByDefault = false
  } = {}
) => {
  const [isLoading, setIsLoading] = useState(false);

  const recentlyPlayed = useGamesStore('recentlyPlayed');

  const { suggesterServiceEntityName } = useCasinoSettings(casinoType);

  const recentlyGamesIsLoaded =
    recentlyPlayed[suggesterServiceEntityName]?.isLoaded;
  const [user] = useContext(UserContext);
  const { role } = user;
  const { showRecentlyPlayedCategory } = useComponentConfig();

  const fetchGamesPlex = useGetLoadFeedGamesCallback();

  useEffect(() => {
    (async () => {
      if (
        role === USER_ROLES.USER &&
        !recentlyGamesIsLoaded &&
        !isLoading &&
        (isShowRecentlyPlayedCategoryByDefault || showRecentlyPlayedCategory) &&
        isRecentDataRequired
      ) {
        setIsLoading(true);
        const gamesLaunchIds = await GET_RECENTLY_PLAYED_LIST(
          suggesterServiceEntityName
        );

        // TODO: for some reason get called 2 times in lobby
        if (IS_USE_PLEX_API && !isEmpty(gamesLaunchIds)) {
          fetchGamesPlex({
            filter: { launchId: gamesLaunchIds.slice(0, limit), limit }
          });
        }
        setIsLoading(false);
      }
    })();
  }, [
    role,
    recentlyGamesIsLoaded,
    suggesterServiceEntityName,
    showRecentlyPlayedCategory,
    fetchGamesPlex,
    feedName,
    limit,
    isRecentDataRequired,
    isShowRecentlyPlayedCategoryByDefault
  ]);

  useEffect(() => {
    // reset recently played after leaving casino section to refetch each time user visits casino
    return () => {
      RESET_RECENTLY_PLAYED_LIST(suggesterServiceEntityName);
    };
  }, [suggesterServiceEntityName]);
};
